#@import $
#@import moment
#@import moment-timezone
#@import Booking
#@import Booking.Models.Booker
#@import Booking.Views.Booker
#@export Booking.dealBookerInit

Booking.dealBookerInit = (payload, done = ->) ->
  return done() unless payload

  Booking.bhw = 'BookingEngineDealBooker'

  {deal, timezoneData, el, failed, error, overlapWith, metasSettings, preset, textNotifications, showDTF, isDTF} = payload

  moment.tz.add timezoneData

  {partialIntent} = preset if preset?

  showAdditionalAttributes = !showDTF
  model = new Booking.Models.Booker {deal, bookAndBuy: true, textNotifications, partialIntent, isDTF, showAdditionalAttributes}
  model.preset(preset)

  return done() unless model.get('options').selectable().length

  view = new Booking.Views.Booker
    optionSelectable: true
    el: el or '#deal-booker'
    overlapWith: overlapWith or '#purchase-cluster .buy, #purchase-cluster .buy-for-friend-module, #purchase-cluster .limited-time, #purchase-cluster .deal-status, #purchase-cluster .deal-discount, #purchase-cluster .gift-card'
    model: model
    templateName: 'deal_booker'
    metasSettings: metasSettings
    showInfo: true

  model.get('availability').on 'error', -> failed?.apply this, arguments
  model.get('reservations').on 'error', -> error?.apply this, arguments
  model.get('reservations').on 'sync', (reservation) ->
    option = model.get('options').get(reservation.getOption().id)
    view.trigger 'buy', option, reservation

  model.on 'buy', (model) ->
    option = model.getSelectedOption()
    view.trigger 'buy', option

  view.on 'buy', (option, reservation) ->
    buyUrl = option.get('buyUrl')
    separator = if buyUrl.match /\?/ then '&' else '?'

    if reservation
      buyUrl += "#{separator}booking_reservation_id=#{reservation.get('id')}"
      buyUrl += "&dtf=#{isDTF}" if isDTF
    else
      buyUrl += "#{separator}book_later=true"
      buyUrl += "&dtf=#{isDTF}" if isDTF

    window.location = buyUrl

  $ ->
    view.setOpenAndLocked() unless $('#purchase-cluster .buy').length
    view.render()

    done()
